<script setup>
import { ref, defineEmits } from "vue";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { useTerritoriosStore } from "@/store/territorios";
import { useCatalogos } from "@/composables/useCatalogos";
import { useAppToast } from "@/composables/useAppToast";

const territorios = useTerritoriosStore();
const cat = useCatalogos();
const toast = useAppToast();
const emit = defineEmits(["saved"]);

const visible = ref(false);
const saving = ref(false);
const nombre = ref("");
const zonaId = ref(null);

const open = () => {
  nombre.value = "";
  zonaId.value = null;
  visible.value = true;
};

const save = async () => {
  const name = nombre.value.trim();
  if (!name) {
    toast.warn("Falta el nombre", "Ingrese el nombre del grupo.");
    return;
  }

  saving.value = true;
  try {
    const created = await cat.createGrupo({ name, zonaId: zonaId.value });
    if (created?.error) {
      toast.error("Ocurrió un error", created.error);
      return;
    }
    const grupo = { id: created.id, name: created.name ?? name, zonaId: zonaId.value };
    territorios.grupos.push(grupo);
    emit("saved", grupo.id);
    visible.value = false;
  } finally {
    saving.value = false;
  }
};
</script>

<template>
  <div class="inline-block">
    <Button label="Nuevo grupo" icon="pi pi-plus" text size="small" @click="open" />
    <Dialog
      v-model:visible="visible"
      modal
      header="Nuevo grupo de predicación"
      :style="{ width: '360px' }"
    >
      <div class="flex flex-column gap-3">
        <div>
          <label class="pb-1">Nombre</label>
          <InputText
            v-model="nombre"
            placeholder="Ej: 6"
            autofocus
            class="w-full"
            @keyup.enter="save"
          />
        </div>
        <div>
          <label class="pb-1">Zona <span class="text-xs text-500">(opcional)</span></label>
          <Dropdown
            v-model="zonaId"
            :options="territorios.zonas"
            option-label="name"
            option-value="id"
            placeholder="Sin zona"
            showClear
            class="w-full"
          />
        </div>
      </div>
      <template #footer>
        <Button label="Cancelar" icon="pi pi-times" text @click="visible = false" />
        <Button label="Guardar" icon="pi pi-check" :loading="saving" @click="save" />
      </template>
    </Dialog>
  </div>
</template>
